import { render } from "./clientTabsMenu.html?vue&type=template&id=05f92350&scoped=true&ts=true&external"
import script from "./ClientTabsMenu.vue?vue&type=script&lang=ts"
export * from "./ClientTabsMenu.vue?vue&type=script&lang=ts"

import "./ClientTabsMenu.vue?vue&type=style&index=0&id=05f92350&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05f92350"]])

export default __exports__